/**
 * Shared Stripe Elements appearance config.
 * Used by both CheckoutPage (initial mount) and StripePaymentForm (live sync).
 */
export function getStripeAppearance(isDark: boolean) {
  return isDark
    ? {
        theme: 'night' as const,
        variables: {
          borderRadius: '8px',
          colorBackground: 'hsl(20, 15%, 11%)',
          colorText: 'hsl(40, 15%, 94%)',
        },
      }
    : {
        theme: 'stripe' as const,
        variables: { borderRadius: '8px' },
      }
}
